import { Buttons } from "@/ui/Buttons";
import { ParallaxBackground } from "@/ui/ParallaxBackground";
import cn from "classnames";
import { Col, Container, Row } from "react-bootstrap";
import { Parallax } from "react-scroll-parallax";

import bg_1 from "./bg_1.webp";
import bg_2 from "./bg_2.webp";
import classes from "./styles.module.scss";

export default function ({
  className = "py-md-6",
  title,
  description,
  image,
  buttons,
  EditableText,
  EditableHtml,
  EditableImage,
  theme = "light",
}) {
  return (
    <div className={cn(className, classes.OurAwards)} data-bs-theme={theme}>
      <ParallaxBackground anim="y1n:x0:z1" image={bg_1} className={classes.bg_1} />
      <ParallaxBackground anim="y1:x0:z0" image={bg_2} floating={false} className={classes.bg_2} />
      <Container fluid="md">
        <Row>
          <Col xs={12} md={6}>
            <EditableText path="title" tag="h2" className="mb-3">
              <span dangerouslySetInnerHTML={{ __html: title }} />
            </EditableText>
            <EditableHtml path="description">
              <div dangerouslySetInnerHTML={{ __html: description }} />
            </EditableHtml>
            <Buttons buttons={buttons} className="mt-4 justify-content-md-start" />
          </Col>
          <Col xs={12} md={6} className="position-relative mt-4 pt-5 mt-md-0 pt-md-0">
            <Parallax translateY={[0, -20]} className={classes.img}>
              <EditableImage path="image_1" src={image} size="463x467" alt="" />
            </Parallax>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
